// Components==============
import React from 'react';
import './ExerciseBottom.module.scss';
// =========================

type Props = {
    controlBar: React.ReactNode;
    soundBar?: React.ReactNode;
};

export default function ExerciseBottom({ controlBar, soundBar }: Props) {
    return (
        <div styleName="wrapper">
            {soundBar && soundBar} {controlBar && controlBar}
        </div>
    );
}
